import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "../context/AuthProvider";

/**
 * Muro de pago del contenido en vivo.
 *
 * El perfil público de la modelo es libre; entrar a la sala exige sesión
 * (ProtectedRoute) y una recarga vigente. La decisión la toma el backend y se
 * publica en `access`: aquí solo se refleja, para que el criterio no viva
 * duplicado en dos sitios.
 */
export default function LiveGuard({ children }) {
    const { access, accessLoading } = useAuthContext();
    const location = useLocation();

    if (!access && accessLoading) {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center p-5 mt-5">
                <div className="spinner-border text-gold mb-3" role="status"></div>
                <p className="text-muted">Verificando tu acceso...</p>
            </div>
        );
    }

    if (access && !access.can_watch_live) {
        return (
            <Navigate
                to="/recharge"
                state={{ from: location.pathname, reason: access.denial_reason }}
                replace
            />
        );
    }

    return children;
}
